import { ActionIcon, Tooltip } from '@mantine/core'
import { DateTimePicker } from '@mantine/dates'
import { useForm } from '@mantine/form'
import { zodResolver } from 'mantine-form-zod-resolver'
import { z } from 'zod'

import { ActivityLogType, CallDirection } from 'src/graphql/types/activityLogs'
import IconPhoneCall from 'src/icons/IconPhoneCall'

const CallInput = ({ onCreate }) => {
  const callInputSchema = z.object({
    activityDate: z.date(),
  })

  const form = useForm({
    initialValues: {
      activityDate: new Date(),
    },

    validate: zodResolver(callInputSchema),
  })

  const onFormSubmit = (values) => {
    onCreate({
      type: ActivityLogType.CALL,
      callDirection: CallDirection.OUTBOUND,
      ...values,
    })
    form.reset()
    form.setFieldValue('activityDate', null)
  }

  return (
    <form onSubmit={form.onSubmit((values) => onFormSubmit(values))}>
      <div className="flex flex-row items-center gap-1 rounded-lg border px-2">
        <DateTimePicker
          variant="unstyled"
          placeholder="Enter date here..."
          className="flex-1"
          valueFormat="MM/DD/YYYY hh:mm A"
          withAsterisk
          maxDate={new Date()}
          clearable
          {...form.getInputProps('activityDate')}
        />
        <Tooltip label="Register call" position="top" className="text-xs">
          <ActionIcon
            type="submit"
            disabled={!form.isValid()}
            variant="transparent"
            size={28}
            radius="md"
            aria-label="Register call"
            className="bg-doubleNickel-brand-500 transition-colors hover:bg-doubleNickel-brand-700 disabled:bg-doubleNickel-gray-100"
          >
            <IconPhoneCall
              fill="none"
              className={`h-4 w-4 ${
                form.isValid()
                  ? 'stroke-doubleNickel-white'
                  : 'stroke-doubleNickel-gray-400'
              }`}
            />
          </ActionIcon>
        </Tooltip>
      </div>
    </form>
  )
}

export default CallInput
